<template>
  <div v-if="datasource.length > 0" :style="divStyle">
    <span class="editor-title">{{ tabList.processNm }}</span>
    <v-expansion-panels v-model="expandedPanel" accordion class="mt-3">
      <v-expansion-panel v-for="(data, i) in datasource" :key="i">
        <v-expansion-panel-header v-bind:color="titleColorList[i] ? titleColorList[i].color : 'grey'" @click="titleClick(i)">
          <v-row no-gutters align="center">
            <v-col cols="8">
              <!-- Main Titile -->
              <v-text-field v-if="data.__created__" :style="mainStyle" v-model="data.workNm" />
              <span v-else :style="mainStyle">{{ data.workNm }}</span>
            </v-col>
            <v-col cols="4" align="center">
              <span :style="mainStyle">(유해위험요인: {{ data.cnt }})</span>
              <v-tooltip right color="primary" max-width="300px">
                <template v-slot:activator="{ on }">
                  <span>
                    <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                  </span>
                </template>
                <div class="tooltip-text">{{ '해당 항목은 저장 후 갱신됩니다.' }}</div>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <!-- 위험성평가 작성 -->
          <v-card v-for="(row, index) in data.factor" :key="index" width="100%" class="addable-card d-flex mt-4 pa-0">
            <div class="addable-left">
              <!-- 삭제 버튼 -->
              <v-btn text @click="removeRow(i, index)" height="calc(100% - 24px)" class="rounded-pill ma-3 pa-2" :color="'error'">
                <svg-icon icon-class="minus" style="height:20px" />
              </v-btn>
            </div>
            <v-card width="100%" class="pa-4 addable-contents">
              <v-form style="width:100%;" ref="form">
                <!-- 평가일시와 위험분류 -->
                <v-row no-gutters class="mb-2" style="background-color: #56a4ff; color:white;">
                  <v-card width="100%" class="d-flex align-center justify-center ma-2"></v-card>
                </v-row>
                <v-row no-gutters>
                  <v-col v-if="row.__created__" cols="12" class="d-flex align-center">
                    <div style="border-radius: 10px; background-color: #6df6ea; width: 11px; height: 11px;"></div>
                    <span class="pl-2">신규 항목</span>
                  </v-col>
                  <v-col v-if="!row.__created__ && row.__updated__" cols="12" class="d-flex align-center">
                    <div style="border-radius: 10px; background-color: #f0ad4e; width: 11px; height: 11px;"></div>
                    <span class="pl-2">수정중인 항목</span>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <!-- 평가일시 -->
                  <v-col cols="6" class="pr-2">
                    <span class="editor-label required">평가일자</span>
                    <v-menu
                      :ref="'menuStDate_' + index"
                      v-model="row.menuStDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      :min-width="100"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formatDate(row.doDt)"
                          append-icon="mdi-calendar"
                          placeholder="평가일시를 선택해주세요"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          solo
                          class="editor_bg"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :ref="'datepicker_' + index + '_' + row.riskFactorId"
                        v-model="row.doDt"
                        no-title
                        scrollable
                        @change="updateItem(data, row)"
                        @input="row.menuStDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <!-- 위험분류 -->
                  <v-col cols="6" class="pl-2">
                    <div class="d-flex align-center justify-space-between">
                      <span class="editor-label required">위험분류</span>
                      <v-tooltip left color="primary" max-width="300px">
                        <template v-slot:activator="{ on }">
                          <span class="editor-label">
                            <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                          </span>
                        </template>
                        <div class="tooltip-text" v-html="divInfo"></div>
                      </v-tooltip>
                    </div>
                    <v-select
                      ref="riskFactorDiv"
                      v-model="row.riskFactorDiv"
                      :items="dataSetList[0].riskFactorList"
                      item-text="minorNm"
                      item-value="minorCd"
                      placeholder="위험분류를 선택해주세요"
                      solo
                      class="editor_bg"
                      :disabled="row.__created__ ? !row.__created__ : true"
                      @change="updateItem(data, row)"
                    >
                      <template v-slot:selection="{ item }">
                        <span class="d-flex" style="width: 100%;">{{ item.minorNm }}</span>
                      </template>
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title>{{ item.minorNm }}</v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>

                <!-- 사고발생시 피해예상자 -->
                <v-row no-gutters class="mt-5">
                  <v-col cols="12">
                    <span class="editor-label">사고발생시 피해예상자</span>
                    <v-select
                      v-model="row.victims"
                      :items="dataSetList[0].victimList"
                      item-text="minorNm"
                      item-value="victimNm"
                      placeholder="피해예상자를 선택해주세요"
                      solo
                      multiple
                      class="editor_bg"
                      @change="handleSelectChange(data, row)"
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip class="ma-0 mr-2" close @click:close="chipClose(data, row, index)">
                          <v-icon left>mdi-account</v-icon>
                          {{ item.minorNm }}
                        </v-chip>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>

                <!-- 유해위험요인 파악 -->
                <v-row no-gutters class="mt-5">
                  <v-col cols="12">
                    <span class="editor-label required">유해위험요인 파악</span>
                    <v-textarea
                      v-model="row.riskFactorContent"
                      solo
                      class="editor_bg"
                      clearable
                      auto-grow
                      spellcheck="false"
                      clear-icon="mdi-close-circle-outline"
                      rows="2"
                      row-height="20"
                      placeholder="유해 위험 요인 파악을 작성해 주세요."
                      :rules="rules"
                      @input="updateItem(data, row)"
                    ></v-textarea>
                  </v-col>
                </v-row>

                <!-- 현재 위험성 수준 -->
                <v-row no-gutters class="mt-5">
                  <v-col cols="12">
                    <span class="editor-label">현재 위험성 수준</span>
                    <span>
                      (위험성평가 기법:
                      {{ dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].minorNm }})
                    </span>
                    <!-- 허용 가능한 위험성 기준에 따라 분기 -->
                    <v-simple-table v-if="dataSetList[0].riskEstimation" class="custom-table">
                      <template
                        v-if="dataSetList[0].riskEstimation === '00002' && dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation]"
                      >
                        <tr>
                          <td colspan="2" rowspan="2" class="text-center tableTitle required">현재위험성</td>
                          <td class="text-center tableTitle">{{ getHeaderValue('high') }}</td>
                          <td class="text-center tableTitle">{{ getHeaderValue('middle') }}</td>
                          <td class="text-center tableTitle">{{ getHeaderValue('lower') }}</td>
                        </tr>
                        <tr :key="tableComponentKey">
                          <td>
                            <v-radio-group v-model="row.riskEstimationVal1" row style="display:flex; justify-content:center !important;">
                              <v-radio
                                color="radio"
                                v-model="dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].data[0].minorCd"
                                style="margin-left: 16px !important;"
                                @change="updateItem(data, row)"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                          <td>
                            <v-radio-group v-model="row.riskEstimationVal1" row style="display:flex; justify-content:center !important;">
                              <v-radio
                                color="radio"
                                v-model="dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].data[1].minorCd"
                                style="margin-left: 16px !important;"
                                @change="updateItem(data, row)"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                          <td>
                            <v-radio-group v-model="row.riskEstimationVal1" row style="display:flex; justify-content:center !important;">
                              <v-radio
                                color="radio"
                                v-model="dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].data[2].minorCd"
                                style="margin-left: 16px !important;"
                                @change="updateItem(data, row)"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr>
                          <td colspan="2" rowspan="2" class="text-center tableTitle required">현재위험성</td>
                          <td class="text-center tableTitle required">빈도</td>
                          <td class="text-center tableTitle required">강도</td>
                          <td class="text-center tableTitle">위험성</td>
                        </tr>
                        <tr :key="tableComponentKey">
                          <td>
                            <v-select
                              v-model="row.riskEstimationVal1"
                              :items="dataSetList[0].freqList"
                              item-text="minorNm"
                              item-value="minorCd"
                              solo
                              class="editor_bg"
                              @change="updateItem(data, row)"
                            >
                              <template v-slot:selection="{ item }">
                                <div class="text-center">{{ item.minorNm }}</div>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title>{{ item.minorNm }}</v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </v-select>
                          </td>
                          <td>
                            <v-select
                              v-model="row.riskEstimationVal2"
                              :items="dataSetList[0].strengthList"
                              item-text="minorNm"
                              item-value="minorCd"
                              solo
                              class="editor_bg"
                              @change="updateItem(data, row)"
                            >
                              <template v-slot:selection="{ item }">
                                <div class="text-center">{{ item.minorNm }}</div>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title>{{ item.minorNm }}</v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </v-select>
                          </td>
                          <td class="text-center" style="width:110px;">{{ getRiskLevel(row) }}</td>
                        </tr>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>

                <!-- 현재의 안전보건조치 -->
                <!-- <v-row no-gutters class="mt-5">
                  <v-col cols="12">
                    <span class="editor-label">현재의 안전보건조치</span>
                    <v-textarea
                      ref="currentShMeasures"
                      v-model="row.currentShMeasures"
                      solo
                      class="editor_bg"
                      clearable
                      auto-grow
                      spellcheck="false"
                      clear-icon="mdi-close-circle-outline"
                      rows="2"
                      row-height="20"
                      placeholder="현재의 안전보건조치을 작성해 주세요."
                      @input="updateItem(data, row)"
                    ></v-textarea>
                  </v-col>
                </v-row>-->
              </v-form>
            </v-card>
          </v-card>

          <v-btn elevation="0" @click="addRow(i)" width="100%" height="48" class="table-add-btn mt-4">
            <svg-icon icon-class="table-add" width="20" height="20" />
          </v-btn>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <div v-else :style="divStyle">
    <h3 class="grey--text d-flex justify-center my-16">데이터가 없습니다.</h3>
  </div>
</template>

<script>
import baseview from '@/views/base/baseview.vue'
// utils
import { getCommonCode } from '@/api/common/commonApi'
import { getCurrentDate } from '@/utils/common.js'
export default {
  mixins: [baseview],
  components: {},

  props: {
    tabList: {
      type: Object,
      default: () => {}
    },
    datasource: {
      type: Array,
      default: () => []
    },
    dataSetList: {
      type: Array,
      default: () => []
    },
    searchProcess: {
      type: Number,
      default: 0
    },
    headerDefaultColor: {
      type: String,
      default: '#fff'
    },
    headerExpandedColor: {
      type: String,
      default: '#fff'
    },
    mainStyle: {
      type: String,
      default: 'font-size: 1rem; font-weight: 600'
    },
    sub1Style: {
      type: String,
      default: 'font-size: 1rem; font-weight: 400;'
    },
    sub2Style: {
      type: String,
      default: 'font-size: 1rem; font-weight: 400'
    },
    textStyle: {
      type: String,
      default: 'font-size: medium;'
    },
    divStyle: {
      type: String,
      default: ''
    },
    firstDataExpand: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      divInfo: '위험분류는 수정이 불가합니다. </br>  위험분류는 최초 입력시에만 입력 가능합니다.',
      tableComponentKey: 0,
      selectedVictims: [], // 선택된 피해예상자 값
      rules: [value => !!value || '필수 입력값입니다.'],
      componentKey: 0,
      victim: '',
      color: 'grey',
      // standardList: ['기준 1', '기준 2', '기준 3'],
      // standard: '',
      // opinion: '',
      menuStDate: false,
      //위험성 추정 기준
      radioData: 'middle',
      test: false,
      tempRiskFactorIdCount: 0,
      expandedPanel: [],
      titleColorList: [
        {
          color: 'grey'
        }
      ],
      riskValueGroup: []
    }
  },
  watch: {
    datasource() {
      let tempColorList = []
      this.datasource.forEach((row, rowIndex) => {
        let defaultColor = {
          color: this.headerDefaultColor
        }
        tempColorList.push(defaultColor)
        row.factor.forEach(el => {
          if (!el.doDt) {
            el.doDt = getCurrentDate() // 현재 날짜
          }
        })
        //패널 초기화
        if (this.searchProcess == rowIndex || this.searchProcess == 0) {
          // let index = this.datasource.findIndex(element => element.processId == this.datasource[0].processId)
          let index = this.searchProcess
          this.expandedPanel = index

          if (tempColorList[index]) {
            tempColorList[index].color = this.headerExpandedColor
          } else {
            tempColorList[index] = { color: this.headerExpandedColor }
          }
        }
      })
      this.titleColorList = tempColorList
    }
  },
  computed: {
    mobileTrigger: function() {
      return this.width < 800
    }
  },
  created() {},
  beforeMount() {},
  mounted() {
    this.setData()
    this.titleColorList = []
    this.datasource.forEach((row, i) => {
      let defaultColor = {
        color: i == 0 && this.firstDataExpand ? this.headerExpandedColor : this.headerDefaultColor
      }
      this.titleColorList.push(defaultColor)
    })

    if (this.firstDataExpand) {
      this.expandedPanel = [0]
    }
  },
  activated() {},
  methods: {
    handleSelectChange(data, item) {
      item.victims = item.victims.map(victimName => {
        // 선택된 피해예상자의 minorNm을 기반으로 victimList에서 해당 객체를 찾음
        return this.dataSetList[0].victimList.find(victim => victim.minorNm === victimName)
      })

      // 피해예상자를 로깅

      // // 선택된 피해예상자 필수값 데이터 가공
      item.victims.forEach(el => {
        el.victimId = el.minorCd
        el.victimNm = el.minorNm
        el.__created__ = true
      })
      this.updateItem(data, item)
    },

    chipClose(data, row, index) {
      row.victims.splice(index, 1)
      this.tableComponentKey++
      this.updateItem(data, row)
    },
    getRiskLevel(row) {
      let value1 = this.dataSetList[0].riskEstimationValue.find(el => el.minorCd == row.riskEstimationVal1)
      let value2 = this.dataSetList[0].riskEstimationValue.find(el => el.minorCd == row.riskEstimationVal2)

      if (value1 && value2) {
        row.riskEstimationNum1 = value1.extra3
        row.riskEstimationNum2 = value2.extra3
      }
      if (this.dataSetList[0].freqValueList.length > 0) {
        let data = this.dataSetList[0].freqValueList.find(el => el.minorCd == row.riskEstimationNum1 * row.riskEstimationNum2)
        return data ? data.minorNm : ''
      }
      return ''
    },
    //추가버튼
    addRow(i) {
      // this.$refs.riskFactorDiv[i].disabled = false
      let data = this.datasource[i]
      const row = {
        clntId: data.clntId,
        compId: data.compId,
        writeDt: data.writeDt,
        docNo: data.docNo,
        constructId: data.constructId,
        processId: data.processId,
        workId: data.workId,
        riskFactorId: 'temp_' + this.tempRiskFactorIdCount++,
        riskFactorDiv: '',
        useYn: 'Y',
        doDt: getCurrentDate(),
        riskEstimationVal1: this.dataSetList[0].riskInit.riskEstimationVal1,
        riskEstimationVal2: this.dataSetList[0].riskInit.riskEstimationVal2,
        __created__: true
      }
      data.factor.push(row)
    },
    //삭제버튼
    removeRow(i, index) {
      console.log('삭제버튼', this.datasource[i].factor[index])
      this.datasource[i].__updated__ = true
      this.datasource[i].factor[index].__updated__ = true
      this.datasource[i].factor[index].useYn = 'N'
      if (!this.datasource[i].factor[index].__created__) {
        // 신규데이터 입력 중 삭제는 push하지 않는다.
        this.dataSetList[0].deleteList.push(this.datasource[i].factor[index])
      }
      this.datasource[i].factor.splice(index, 1)
    },
    titleClick(index) {
      let indexback = index
      if (this.titleColorList[index].color === this.headerDefaultColor) {
        this.titleColorList[index].color = this.headerExpandedColor
        this.titleColorList.forEach(element => {
          if (element != this.titleColorList[index]) element.color = this.headerDefaultColor
        })
      } else {
        this.titleColorList[index].color = this.headerDefaultColor
      }

      this.$emit('titleClick', index)
    },

    forceRerender() {
      this.componentKey += 1
    },
    getHeaderValue(code) {
      let data = this.riskValueGroup.find(element => element.minorCd == code)
      let text = `${data.minorNm}(${data.extra3})`
      return text
    },
    updateItem(data, row) {
      if (!data.__updated__) data.__updated__ = true
      if (!row.__updated__) row.__updated__ = true
    },
    ///////////////////////////////////////
    /*               Event               */
    ///////////////////////////////////////
    // formatDate(date) {
    //   if (!date) return null

    //   if (date.indexOf('-') > -1) {
    //     const [year, month, day] = date.split('-')
    //     return `${year}.${month}.${day}`
    //   } else {
    //     return date
    //   }
    // },
    formatDate(date) {
      if (!date) return null

      if (date.indexOf('-') == -1) {
        const year = date.substring(0, 4)
        const month = date.substring(4, 6)
        const day = date.substring(6, 8)
        return `${year}-${month}-${day}`
      } else if (date.indexOf('-') > -1) {
        const [year, month, day] = date.split('-')
        return `${year}.${month}.${day}`
      } else {
        return date
      }
    },
    setData() {
      Promise.all([getCommonCode('RA002_1')]).then(response => {
        this.riskValueGroup = response[0].list
      })
    }
  }
}
</script>

<style lang="scss"></style>
